import { render, staticRenderFns } from "./report-mlgp.vue?vue&type=template&id=3e856c6c&"
import script from "./report-mlgp.vue?vue&type=script&lang=js&"
export * from "./report-mlgp.vue?vue&type=script&lang=js&"
import style0 from "./report-mlgp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports